var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2073_9984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0046 -0.0102539C6.71995 -0.0102539 0.00463867 6.70506 0.00463867 14.9897C0.00463867 23.2735 6.71995 29.9897 15.0046 29.9897C23.2893 29.9897 30.0046 23.2735 30.0046 14.9897C30.0046 6.706 23.2893 -0.0102539 15.0046 -0.0102539Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7804 21.499V15.7455C22.7804 12.663 21.135 11.2287 18.9404 11.2287C17.1694 11.2287 16.3763 12.2027 15.9347 12.8862V11.464H12.5991C12.6432 12.4062 12.5991 21.499 12.5991 21.499H15.9347V15.8946C15.9347 15.5955 15.9563 15.2955 16.0444 15.0818C16.2854 14.4827 16.8338 13.8621 17.7554 13.8621C18.9629 13.8621 19.4457 14.7818 19.4457 16.1308V21.4999L22.7804 21.499ZM9.08441 10.0943C10.2469 10.0943 10.9716 9.32271 10.9716 8.3599C10.95 7.37553 10.2469 6.62646 9.10598 6.62646C7.96504 6.62646 7.21973 7.37459 7.21973 8.35897C7.21973 9.32272 7.94348 10.0933 9.06379 10.0933H9.08441V10.0943ZM10.7522 21.499V11.464H7.41754V21.499H10.7522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2073_9984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1420d192a95f908055d833af0b667454.svg";
export { ForwardRef as ReactComponent };